import { DeleteByOrgUnitOrgUser } from 'domain/usecases/orgUser/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteDeleteByOrgUnitOrgUser implements DeleteByOrgUnitOrgUser {
  private readonly url: string;

  private readonly httpClient: HttpClient<DeleteByOrgUnitOrgUser.Model>;

  constructor(
    url: string,
    httClient: HttpClient<DeleteByOrgUnitOrgUser.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  deleteByOrgUnit = async (
    params: DeleteByOrgUnitOrgUser.Params,
  ): Promise<DeleteByOrgUnitOrgUser.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url
        .replace('{orgId}', `${params.orgId}`)
        .replace('{unitId}', `${params.unitId}`)
        .replace('{userId}', `${params.userId}`),
      method: 'delete',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
